import { render } from "./AppointmentsManagement.vue?vue&type=template&id=522e913c&scoped=true"
import script from "./AppointmentsManagement.vue?vue&type=script&lang=js"
export * from "./AppointmentsManagement.vue?vue&type=script&lang=js"

import "./AppointmentsManagement.vue?vue&type=style&index=0&id=522e913c&lang=css"
import "./AppointmentsManagement.vue?vue&type=style&index=1&id=522e913c&scoped=true&lang=css"

import exportComponent from "/Applications/PROJECTS/HMS-MAIN/PORTAL/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-522e913c"]])

export default __exports__